import {Component, OnInit, Inject} from '@angular/core';
import {ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import { MatTableDataSource} from '@angular/material/table';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ConfirmComponent} from '../../../shared/dialogs/confirm/confirm.component';
import {ReportsSubscriptionsService} from '../../reports-subscriptions.service';
import {AgendaService} from 'src/app/services/agenda.service';
import {EventService} from 'src/app/services/event.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-report-subscription-staff-dialog',
  templateUrl: './report-subscription-staff-dialog.component.html',
  styleUrls: [ './report-subscription-staff-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})
export class ReportSubscriptionStaffDialogComponent implements OnInit {

  public Editor = ClassicEditor;

  public local_title: string;
  public matcher = new FormErrorStateMatcher();
  public entityForm: FormGroup;   // store User Form
  public isEdit: boolean; // is insert or update
  public spinner: boolean = false;

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'name' ]

  constructor (
    public matDialogRef: MatDialogRef<ReportSubscriptionStaffDialogComponent>,
    public _reportsSubscriptionsService: ReportsSubscriptionsService,
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    public _agendaService: AgendaService,
    public _eventService: EventService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // console.log("MAT_DIALOG_DATA: " + JSON.stringify(this.data));
    this.getAgenda()
  }


  ngOnInit () {
    this._adapter.setLocale('pt');
    this.local_title = "Inscrição"
    this.entityForm = this.createForm()
    this.setFormValues(this.data.entity, this.entityForm)
  }

  setFormValues (data, form) {

    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);
    form.controls.email.setValue(data.email);
    form.controls.cpf.setValue(data.cpf);
    form.controls.text.setValue(data.text);
    form.controls.image.setValue(data.image);

    this._reportsSubscriptionsService.storedImage = data.image;

  }

  createForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [ Validators.required ]),
      email: new FormControl('', [ Validators.required ]),
      cpf: new FormControl('', [ Validators.required ]),
      text: new FormControl(''),
      image: new FormControl('')
    });
    return form
  }


  getAgenda () {

    let appointments: any = [];

    this._eventService.selectEventCongress()
      .subscribe((events) => {
        let eventArray: any = []

        events.forEach((item) => {
          let entity: any = {};
          entity = item.payload.doc.data()
          entity.id = item.payload.doc.id
          eventArray.push(entity)
        })

        eventArray.forEach(item => {

          this._agendaService.loadAllMemberAgendaByEvent(this.data.entity.id, item.id)
            .subscribe((rets) => {

              //  console.log("event.id: " + item.id)
              //  console.log("member.id: " + this.memberSelected.id)

              rets.forEach((ret) => {

                let etty: any = {}
                etty = ret.payload.doc.data();
                etty.id = ret.payload.doc.id

                // console.log("etty: " + JSON.stringify(etty))
                appointments.push(etty)
                //   console.log("appointments: " + JSON.stringify(appointments))
                this.dataSource = new MatTableDataSource(appointments);
              })
            })
        });

        //  console.log("appointmentsss final: " + JSON.stringify(appointments))
        // this.dataSource = new MatTableDataSource(appointments);
      })

  }

}
